import _ from "lodash";

import {
  getAssessmentQuery,
  getAssessmentPreviewQuery,
  getAssessmentOfUnitQuery,
  getParentAssesmentQuery,
  getAssessmentBasicDetailsQuery,
  getAssessmentCourseDetailsQuery,
  getFieldListQuery,
  getAssessmentLearningCourseDetailsQuery,
  getAssessmentLinkedAssignmentsQuery,
} from "./AssessmentQuery";
import client from "lib/apolloClient/client";
import {
  assessmentFragment,
  plannerFieldFragment,
} from "Assessments/modules/AssessmentFragments";

export const getAssessmentDetailsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssessmentQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAssessmentPreviewDetailsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssessmentPreviewQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeAssessmentDetailsToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getAssessmentQuery,
      variables,
      data,
    });
  } catch (err) {}
};

export const writeAssessmentFieldFragment = ({ field_id, data }) => {
  client.writeFragment({
    id: `PlannerField:${field_id}`,
    fragment: plannerFieldFragment.resourceLibraryField,
    fragmentName: "resourceLibraryFieldItem",
    data: data,
  });
};

export const writeAssessmentFragment = ({ assessmentId, data, variables }) => {
  try {
    client.writeFragment({
      id: `Assessment:${assessmentId}`,
      fragment: assessmentFragment.assessmentDetails,
      fragmentName: "assessmentItem",
      data,
      variables,
    });
  } catch (err) {
    console.error(err);
  }
};

export const getAssessmentOfUnitFromCache = ({ unitPlanId }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssessmentOfUnitQuery,
      variables: {
        id: unitPlanId,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAssessmentBasicDetailsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssessmentBasicDetailsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getParentAssessmentFromCache = ({
  parentId,
  parentType,
  searchText,
  grades,
  learningCourseIds,
  units,
  academicYears,
  excludeSnPEvidenceFilters,
  curriculumProgramIds,
  first,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getParentAssesmentQuery,
      variables: {
        id: parentId,
        type: parentType,
        searchText,
        grades,
        learningCourseIds,
        academicYears,
        units,
        curriculumProgramIds,
        excludeSnPEvidenceFilters,
        first,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAssessmentCourseDetailsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getAssessmentCourseDetailsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getAssessmentLearningCourseDetailsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getAssessmentLearningCourseDetailsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getFieldListFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getFieldListQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getAssessmentLinkedAssignmentsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getAssessmentLinkedAssignmentsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeAssessmentLinkedAssignmentsInCache = ({
  variables,
  data,
}) => {
  try {
    client.writeQuery({
      query: getAssessmentLinkedAssignmentsQuery,
      variables,
      data,
    });
  } catch (err) {}
};
